// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"866":"6468630d","6083":"798901a7"}[chunkId] || chunkId) + "." + {"866":"2b93336638de51e0","3143":"5560bdf8165edee6","6083":"3b19dfde62b4b66d","7585":"5fceab46442fcc39"}[chunkId] + ".js";
};